// extracted by mini-css-extract-plugin
export var banner = "_7-0";